<template>
  <div class="container">
    <!-- <nav-bar rightShow="false" @leftClick="leftClick"></nav-bar> -->
    <div class="item-container">
      <div class="menu-content">
        <menu-list name="关于设备" subName="" @click.native="goPage('equipment')"></menu-list>
        <menu-list name="秒秒测智能健康日历服务协议" subName="" @click.native="goPage('agreement')"></menu-list>
       <!--  <menu-list name="固件升级" subName="" @click.native="goPage('version')"></menu-list> -->
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '../../components/NavBar/NavBar.vue'
import MenuList from '../../components/MenuList/MenuList.vue'
import Common from '../../assets/js/common.js'
export default {
  components: {
    NavBar,
    MenuList
  },
  methods: {
    leftClick () {
      this.$router.push({path: '/Setting'})
    },
    goPage (e) {
      if (e === 'equipment') {
        this.$router.push({path: '/AboutEquipment'})
      } else if (e === 'version') {
        this.$router.push({path: '/VersonUpdate'})
      } else if (e === 'agreement') {
        this.$router.push({path: '/Agreement'})
      }
    }
  },
  created () {
    Common.setTitle('关于')
  }
}
</script>
<style lang="stylus" scoped>
.item-container
  height calc(100% - 56px)
  overflow auto
  .menu-content
    border-top 1px solid #ededed
    padding 0 16px
    background #ffffff
</style>


// WEBPACK FOOTER //
// src/pages/About/About.vue